import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { AuthUser } from '../types/auth';

const AUTHORIZATION_KEY = 'authorization';

export const getAuthUserInSession = () => {
  try {
    const rawToken = Cookies.get(AUTHORIZATION_KEY);
    if (!rawToken) {
      return AuthUser.parse({});
    }

    try {
      const decoded = jwtDecode(rawToken);
      return AuthUser.parse(decoded);
    } catch (_e) {
      return AuthUser.parse({});
    }
  } catch (_e) {
    return AuthUser.parse({});
  }
};

export const setAuthUserInSession = (rawToken: string) => {
  try {
    try {
      const decoded = jwtDecode(rawToken);
      const expiresAtSeconds = decoded.exp ?? 0;
      // js-cookie reads a number as days, so the absolute expiry (the JWT `exp`) must be passed as a Date.
      Cookies.set(AUTHORIZATION_KEY, rawToken, {
        expires: new Date(expiresAtSeconds * 1000),
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
      });
      return AuthUser.parse(decoded);
    } catch (_e) {
      return AuthUser.parse({});
    }
  } catch (_e) {
    return AuthUser.parse({});
  }
};

export const removeAuthUserInSession = () => {
  try {
    Cookies.remove(AUTHORIZATION_KEY);
    return AuthUser.parse({});
  } catch (_e) {
    return AuthUser.parse({});
  }
};

export const getAuthToken = () => {
  try {
    return Cookies.get(AUTHORIZATION_KEY);
  } catch (_e) {
    return undefined;
  }
};
